// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"2269780d","378":"34959ca6","423":"b33020e9","435":"89bb052b","447":"229a0077","620":"451d8074","649":"233d60a4","722":"86b54bae","763":"4dcb9408"}[chunkId] + ".chunk.js";
};